import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CtaComponent } from '../cta/cta.component';

@Component({
  selector: 'app-media-card',
  imports: [CtaComponent],
  templateUrl: './media-card.component.html',
  styleUrl: './media-card.component.scss',
})
export class MediaCardComponent {
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() imageUrl: string = '';
  @Input() link: string = '';
  @Input() btnText: string = '';
}
